import { createDefaultMutationHook } from "hooks/useMutationHandler";

import { RUN_EXTERNAL_DEPENDENCY_MARK_AS_COMPLETED } from "./gql";

const useSkipExternalDependency = createDefaultMutationHook(
  RUN_EXTERNAL_DEPENDENCY_MARK_AS_COMPLETED
);

export default useSkipExternalDependency;
